import api from './api';

const resource = 'PublicCoupon/';

// The Coupons list's query (spec 2026-10-21 §2.2): one company, a status
// set, a page, an optional exact `code` and the api's case-insensitive
// name-or-code `search`. Statuses repeat the key (`status=0&status=1`),
// the form ASP.NET binds to List<CouponStatus>.
export const listQuery = ({ companyid, statuses = [], pageNumber = 1, pageSize = 10, code = '', search = '' } = {}) => {
  const params = new URLSearchParams();
  if (companyid) params.set('companyid', companyid);
  params.set('PageNumber', String(pageNumber));
  params.set('PageSize', String(pageSize));
  statuses.forEach((status) => params.append('status', String(status)));
  if (code) params.set('code', code);
  const term = String(search || '').trim();
  if (term) params.set('search', term);
  return `?${params.toString()}`;
};

// A string is passed through as it is (the QA specs build their own).
export const list = async (query = '') => {
  return await api.get(resource + 'List' + (typeof query === 'string' ? query : listQuery(query || {})));
};

export const getById = async (id) => {
  return await api.get(resource + 'Get?id=' + id);
};

export const upsert = async (body) => {
  return await api.post(resource + 'Upsert', body);
};

export const deleteById = async (id) => {
  return await api.delete(resource + 'Delete?id=' + id);
};

// GET PublicCoupon/CodeAvailability (spec §1.2). `excludeid` is the
// campaign being edited; a new campaign leaves it out.
export const codeAvailability = async ({ companyid, code, excludeid } = {}) => {
  const params = new URLSearchParams({ companyid: companyid || '', code: code || '' });
  if (excludeid) params.set('excludeid', excludeid);
  return await api.get(`${resource}CodeAvailability?${params.toString()}`);
};

// GET PublicCoupon/ProductChoices (spec §1.7): the products a store of the
// company sells, with their items and the stores that sell each one.
export const productChoices = async (companyid) => {
  return await api.get(`${resource}ProductChoices?companyid=${encodeURIComponent(companyid || '')}`);
};

const publicCouponApi = { list, getById, upsert, deleteById, codeAvailability, productChoices };

export default publicCouponApi;
